import CheckBox from "../../components/CheckBox";

import "../css/ButtonCheck.css";

export default ({ text, checked, enabled, onClick }) => {
  return (
    <div
      className={
        "button-check" +
        (checked ? " button-check-checked" : "") +
        (enabled ? " button-check-enabled" : "")
      }
      onClick={enabled ? onClick : null}
    >
      <span>{text}</span>
      <CheckBox active={checked} onClick={() => {}} />
    </div>
  );
};
